/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  price: number;
};

export const Price: FcWithoutChildren<Props> = (props) => {
  const { price } = props;

  return (
    <div css={rootStyle}>
      <p>
        <span>¥</span>
        <span>{price.toLocaleString()}</span>
        {/* TODO: 多言語対応 */}
        <span>税込</span>
      </p>

      <div>[ICON]</div>
    </div>
  );
};

const rootStyle = css`
  display: flex;
  justify-content: space-between;
`;
